import { getLtpConsentTimestamp } from './ltpConsentStorage';
import { getOrCreateLtpSessionId } from './ltpSessionId';

/** dataLayer property name — stringified JSON for GTM / compliance exports. */
export const LTP_CONSENT_RECEIPT_DL_KEY = 'ltp-consent-accept-receipt';

export interface LtpConsentReceiptPayload {
  domain: string;
  timestamp: string;
  country: string;
  state: string;
  deviceType: string;
  browser: string;
  userAgent: string;
  clientId: string;
}

export const getDeviceTypeFromUa = (ua: string): string => {
  if (/ipad/i.test(ua)) {
    return 'tablet';
  }
  if (/android/i.test(ua) && !/mobile/i.test(ua)) {
    return 'tablet';
  }
  if (/mobile|iphone|ipod|android.*mobile|webos|blackberry|iemobile|opera mini/i.test(ua)) {
    return 'mobile';
  }
  return 'desktop';
};

export const getBrowserFromUa = (ua: string): string => {
  if (/edg(e|a|ios)?\//i.test(ua)) {
    return 'Edge';
  }
  if (/opr\/|opera/i.test(ua)) {
    return 'Opera';
  }
  if (/firefox|fxios/i.test(ua)) {
    return 'Firefox';
  }
  if (/crios/i.test(ua)) {
    return 'Chrome';
  }
  if (/chrome|chromium/i.test(ua)) {
    return 'Chrome';
  }
  if (/safari/i.test(ua)) {
    return 'Safari';
  }
  return 'Other';
};

type ReceiptMode = 'accept' | 'restored';

/**
 * US LTP receipts use country `US`. State is not available client-side without geo IP.
 */
export const buildLtpConsentReceiptString = (mode: ReceiptMode): string => {
  const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';
  const clientId = getOrCreateLtpSessionId() || '';
  let timestamp = '';
  if (mode === 'accept') {
    timestamp = getLtpConsentTimestamp() || new Date().toISOString();
  } else {
    timestamp = getLtpConsentTimestamp() || '';
  }

  const payload: LtpConsentReceiptPayload = {
    timestamp,
    clientId,
    domain: typeof window !== 'undefined' ? window.location.hostname : '',
    country: 'US',
    state: '',
    deviceType: getDeviceTypeFromUa(ua),
    browser: getBrowserFromUa(ua),
    userAgent: ua,
  };

  return JSON.stringify(payload);
};
